"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { signInWithEmailAndPassword } from "firebase/auth"
import { getDatabase, ref, get } from "firebase/database"
import { auth } from "../Firebase/firestore"
import "./admin-login.css"

const AdminLogin = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleLogin = async (event) => {
    event.preventDefault()
    setIsLoading(true)
    setErrorMessage("")

    try {
      // Authenticate with Firebase
      const userCredential = await signInWithEmailAndPassword(auth, email.trim().toLowerCase(), password)
      const user = userCredential.user

      // Check if the user has admin privileges
      const db = getDatabase()
      const adminRef = ref(db, `admins/${user.uid}`)
      const adminSnapshot = await get(adminRef)

      if (adminSnapshot.exists()) {
        // User is an admin, set admin status in local storage
        localStorage.setItem("userToken", user.uid)
        localStorage.setItem("isAdmin", "true")
        localStorage.setItem("adminEmail", email.trim().toLowerCase())

        // Clear any supplier-specific data that might be in localStorage
        localStorage.removeItem("supplierBrand")
        localStorage.removeItem("supplierEmail")
        localStorage.removeItem("currentView")

        // Navigate to admin dashboard
        navigate("/admin-dashboard", { replace: true })
      } else {
        // User is not an admin
        setErrorMessage("You do not have admin privileges.")
        // Sign out the user since they're not an admin
        await auth.signOut()
      }
    } catch (error) {
      // Handle authentication errors
      console.error("Login error:", error)
      switch (error.code) {
        case "auth/user-not-found":
          setErrorMessage("Admin not found. Please check your email.")
          break
        case "auth/wrong-password":
          setErrorMessage("Incorrect password. Please try again.")
          break
        case "auth/too-many-requests":
          setErrorMessage("Too many login attempts. Please try again later.")
          break
        default:
          setErrorMessage("Login failed. Please try again.")
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h1>Admin Login</h1>
          <p className="admin-login-description">Sign in with your admin credentials to manage all supplier data</p>
        </div>

        <form onSubmit={handleLogin} autoComplete="on">
          <div className="admin-input-group">
            <label htmlFor="email" className="admin-input-label">
              Email
            </label>
            <input
              id="email"
              type="email"
              className="admin-input"
              placeholder="Enter admin email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>

          <div className="admin-input-group">
            <label htmlFor="password" className="admin-input-label">
              Password
            </label>
            <input
              id="password"
              type="password"
              className="admin-input"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className={`admin-login-button ${isLoading ? "loading" : ""}`} disabled={isLoading}>
            {isLoading ? "Logging in..." : "Admin Login"}
          </button>

          {errorMessage && <div className="admin-error-message">{errorMessage}</div>}
        </form>

        <div className="admin-login-footer">
          <a href="/login" className="back-to-supplier-login">
            Back to Supplier Login
          </a>
        </div>
      </div>
    </div>
  )
}

export default AdminLogin;

